import styled from 'styled-components';

export const Container = styled.section`
  position: relative;
`;
Container.displayName = 'Container';

export const TimeContainer = styled.div`
  align-items: center;
  border-radius: 4px;
  display: flex;
  font-family: 'Orbitron', sans-serif;
  font-size: 25px;
  font-weight: 500;
  height: 40px;
  justify-content: center;
  left: 110px;
  position: absolute;
  top: 89px;
  width: 141px;
`;
TimeContainer.displayName = 'TimeContainer';

export const Title = styled.div`
  font-size: 17px;
  font-family: 'Orbitron', sans-serif;
  font-weight: 600;
  position: absolute;
  text-align: center;
  width: 415px;
  white-space: pre-wrap;
`;
Title.displayName = 'Title';
